const revealTube = {
  init: () => {
    document.querySelectorAll(".video-modal-open").forEach((modal) => {
      modal.addEventListener("reveal:open", () => {
        const container = modal.querySelector(".video-modal");
        if (!container) {
          return;
        }
        const { youtubeid: youtubeId, title } = container.dataset;
        if (!youtubeId) {
          return;
        }
        container.insertAdjacentHTML(
          "afterbegin",
          `<iframe title="${title ?? ""}" allow="autoplay" src="https://player.cvm3.se/${youtubeId}?fetch=true" frameborder="0" allowfullscreen></iframe>`,
        );
      });

      modal.addEventListener("reveal:closed", () => {
        modal.querySelector(".video-modal iframe")?.remove();
      });
    });
  },
};

export default revealTube;
